module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/thiagoandrade/projects/Dimensional/service.dimensional.meest.com.br/public_html/bedrock/web/app/themes/dim-service/node_modules/axios/index.js
// module id = 19
// module chunks = 0